import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const StudyAbroadSection = () => {
  const navigate = useNavigate();
  useEffect(() => {
    // Register ScrollTrigger plugin with GSAP
    gsap.registerPlugin(ScrollTrigger);

    // Ensure the elements exist before running animations
    const textSection = document.getElementById("text-section");
    const animatedButton = document.getElementById("animated-button");
    const imageSection = document.getElementById("image-section");

    if (textSection && animatedButton && imageSection) {
      // GSAP Scroll-triggered animations
      gsap.to(textSection, {
        y: -200,
        ease: "power1.out",
        scrollTrigger: {
          trigger: textSection,
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
        },
      });

      gsap.to(animatedButton, {
        y: -100,
        ease: "power1.out",
        scrollTrigger: {
          trigger: imageSection,
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
        },
      });
    }

    // return () => {
    //   // Cleanup if needed
    //   ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    // };
  }, []);

  return (
    <section
      id="services"
      className="relative w-full min-h-screen bg-[#1d3557] flex flex-col items-center px-10 overflow-hidden"
    >
      {/* Text Section */}
      <div
        id="text-section"
        className="relative max-w-7xl mx-auto text-white z-10 text-center mt-60"
      >
        <h1 className="text-9xl md:text-[80px] font-bold leading-1 tracking-tighter">
          NOT JUST ANOTHER <br /> STUDY{" "}
          <span className="text-[#457b9d]">ABROAD CONSULTANCY</span>
        </h1>
        <p className="text-gray-400 text-[24px] mt-10 px-0 md:px-16  leading-0 tracking-tight">
          Take the next step toward your global education with SocraticAli. We
          provide a seamless, one-window solution to help you study abroad
          without the hassle. Get expert guidance, guaranteed scholarship
          assistance, and complete digital consultancy, all with no upfront
          fees. Your future starts here.
        </p>
      </div>

      {/* Image Section */}
      <div
        id="image-section"
        className="relative z-0 w-full max-w-[90%] pl-20 mx-auto"
      >
        <img
          src="/Assets/circle.png"
          alt="Consultancy Image"
          className="w-full object-cover rounded-lg shadow-lg"
        />
        <button
          onClick={() => navigate("/signup")}
          id="animated-button"
          className="absolute bottom-5 left-1/2 transform -translate-x-1/2 mt-6 bg-[#457b9d] text-white font-bold px-6 py-3 rounded-md shadow-lg hover:bg-[#1d3557] hover:text-white transition-all duration-300"
        >
          Start Your Journey
        </button>
      </div>
    </section>
  );
};

export default StudyAbroadSection;
